var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUploadGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.691 15.15c-.989-5.02-5.396-8.786-10.69-8.786-4.204 0-7.855 2.385-9.673 5.876a8.719 8.719 0 0 0-7.782 8.67c0 4.814 3.913 8.726 8.727 8.726h18.91a7.275 7.275 0 0 0 7.272-7.272c0-3.84-2.982-6.953-6.764-7.215Zm-.509 11.577H9.273a5.817 5.817 0 0 1-5.818-5.818c0-2.982 2.225-5.469 5.178-5.774l1.557-.16.727-1.382A7.955 7.955 0 0 1 18 9.273a8.004 8.004 0 0 1 7.84 6.443l.437 2.182 2.225.16a4.335 4.335 0 0 1 4.044 4.306c0 2.4-1.964 4.363-4.364 4.363Zm-16-7.272h3.71v4.363h4.218v-4.363h3.709L18 13.636l-5.818 5.819Z",
    fill: "#697885"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadGrey);
export default __webpack_public_path__ + "static/media/CloudUploadGrey.bc294fe8672f2f51d8e7c5b3aa386c9e.svg";
export { ForwardRef as ReactComponent };